import React from 'react';

const IconWhatsApp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-whatsapp"
  >
    <title>WhatsApp</title>
    <path d="M12 2C6.48 2 2 6.48 2 12c0 1.82.49 3.53 1.34 5L2 22l5.14-1.34A9.93 9.93 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
    <path d="M8.5 14.5c2 2 4.5 2.5 6 1.5l1-.5c.5-.3.5-1 0-1.3l-1.5-1c-.4-.3-1-.2-1.3.2l-.5.6c-.2.2-.5.2-.7.1-1-.5-2-1.5-2.5-2.5-.1-.2-.1-.5.1-.7l.6-.5c.4-.3.5-.9.2-1.3l-1-1.5c-.3-.5-1-.5-1.3 0l-.5 1c-1 1.5-.5 4 1.5 6z" />
  </svg>
);

export default IconWhatsApp;
